export default __webpack_public_path__ + "pypi/streamlit-1.36.0-cp312-none-any.whl";